/* import __COLOCATED_TEMPLATE__ from './quarterfinal50-startlist-interface.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

export default class Quarterfinal50StartlistComponent extends Component
{
	@service store;
	@service csv;
	@service sprintTools;

	@tracked sourceEvent;
	@tracked sourceClassGroup;

	@tracked bibOffset = 0;

	@tracked Q1ClassGroup;
	@tracked Q2ClassGroup;
	@tracked Q3ClassGroup;
	@tracked Q4ClassGroup;
	@tracked Q5ClassGroup;

	@tracked top50Results;
	@tracked Q1Assignments;
	@tracked Q2Assignments;
	@tracked Q3Assignments;
	@tracked Q4Assignments;
	@tracked Q5Assignments;

	@tracked startTimeQ1;
	@tracked startTimeQ2;
	@tracked startTimeQ3;
	@tracked startTimeQ4;
	@tracked startTimeQ5;

	@action
	async sourceEventChanged(browserEvent)
	{
		if(browserEvent.target.value == '-')
		{
			this.sourceEvent = null;
			this.sourceClassGroup = null;
		}
		else
		{
			var event = await this.store.findRecord('Event', browserEvent.target.value);
			this.sourceEvent = event;
			this.sourceClassGroup = null;
		}

		this.updateResults();
	}

	@action
	async classGroupChanged(browserEvent)
	{
		if(browserEvent.target.value == '-')
		{
			this.sourceClassGroup = null;
			this.updateResults();
		}
		else
		{
			var classGroup = await this.store.findRecord('ClassGroup', browserEvent.target.value);
			this.sourceClassGroup = classGroup;
		}

		this.updateResults();
	}

	@action
	bibOffsetChanged(browserEvent)
	{
		browserEvent.preventDefault();
		this.updateHeatAssignments();
	}

	@action
	tieSelectionChanged(result, browserEvent)
	{
		result.set('useResultForTie', browserEvent.target.checked);
		this.updateHeatAssignments();
	}

	@action
	async Q1ClassGroupChanged(browserEvent)
	{
		if(browserEvent.target.value == '-')
		{
			this.Q1ClassGroup = null;
		}
		else
		{
			var classGroup = await this.store.findRecord('ClassGroup', browserEvent.target.value);
			this.Q1ClassGroup = classGroup;
			this.startTimeQ1 = dayjs(classGroup.startTime).format("HH:mm:ss");
			this.updateHeatAssignments();
		}
	}

	@action
	async Q2ClassGroupChanged(browserEvent)
	{
		if(browserEvent.target.value == '-')
		{
			this.Q2ClassGroup = null;
		}
		else
		{
			var classGroup = await this.store.findRecord('ClassGroup', browserEvent.target.value);
			this.Q2ClassGroup = classGroup;
			this.startTimeQ2 = dayjs(classGroup.startTime).format("HH:mm:ss");
			this.updateHeatAssignments();
		}
	}

	@action
	async Q3ClassGroupChanged(browserEvent)
	{
		if(browserEvent.target.value == '-')
		{
			this.Q3ClassGroup = null;
		}
		else
		{
			var classGroup = await this.store.findRecord('ClassGroup', browserEvent.target.value);
			this.Q3ClassGroup = classGroup;
			this.startTimeQ3 = dayjs(classGroup.startTime).format("HH:mm:ss");
			this.updateHeatAssignments();
		}
	}

	@action
	async Q4ClassGroupChanged(browserEvent)
	{
		if(browserEvent.target.value == '-')
		{
			this.Q4ClassGroup = null;
		}
		else
		{
			var classGroup = await this.store.findRecord('ClassGroup', browserEvent.target.value);
			this.Q4ClassGroup = classGroup;
			this.startTimeQ4 = dayjs(classGroup.startTime).format("HH:mm:ss");
			this.updateHeatAssignments();
		}
	}

	@action
	async Q5ClassGroupChanged(browserEvent)
	{
		if(browserEvent.target.value == '-')
		{
			this.Q5ClassGroup = null;
		}
		else
		{
			var classGroup = await this.store.findRecord('ClassGroup', browserEvent.target.value);
			this.Q5ClassGroup = classGroup;
			this.startTimeQ5 = dayjs(classGroup.startTime).format("HH:mm:ss");
			this.updateHeatAssignments();
		}
	}

	@action
	exportHeatStartListCSV()
	{
		if (!this.Q1Assignments || !this.Q2Assignments || !this.Q3Assignments || !this.Q4Assignments || !this.Q5Assignments) {
			return;
		}

		var buildData = (assignments, classGroup, startTime) => {
			var data = [...this.sprintTools.getCSVHeaders()];
			for (const result of assignments) {
				data.push(this.sprintTools.buildCSVRow(result, classGroup, startTime, result.newBib));
			}
			return data;
		};

		this.csv.export(buildData(this.Q1Assignments, this.Q1ClassGroup, this.startTimeQ1), {fileName:'Q1quarterfinalsStartlist.csv',withSeparator:false});
		this.csv.export(buildData(this.Q2Assignments, this.Q2ClassGroup, this.startTimeQ2), {fileName:'Q2quarterfinalsStartlist.csv',withSeparator:false});
		this.csv.export(buildData(this.Q3Assignments, this.Q3ClassGroup, this.startTimeQ3), {fileName:'Q3quarterfinalsStartlist.csv',withSeparator:false});
		this.csv.export(buildData(this.Q4Assignments, this.Q4ClassGroup, this.startTimeQ4), {fileName:'Q4quarterfinalsStartlist.csv',withSeparator:false});
		this.csv.export(buildData(this.Q5Assignments, this.Q5ClassGroup, this.startTimeQ5), {fileName:'Q5quarterfinalsStartlist.csv',withSeparator:false});
	}

	@action
	async createClasses()
	{
		var destinationEvent = this.args.destinationEvent;
		var destinationClasses = await destinationEvent.get('classes');

		await this.sprintTools.createClassesForHeat(destinationEvent, destinationClasses, this.Q1ClassGroup, this.Q1Assignments);
		await this.sprintTools.createClassesForHeat(destinationEvent, destinationClasses, this.Q2ClassGroup, this.Q2Assignments);
		await this.sprintTools.createClassesForHeat(destinationEvent, destinationClasses, this.Q3ClassGroup, this.Q3Assignments);
		await this.sprintTools.createClassesForHeat(destinationEvent, destinationClasses, this.Q4ClassGroup, this.Q4Assignments);
		await this.sprintTools.createClassesForHeat(destinationEvent, destinationClasses, this.Q5ClassGroup, this.Q5Assignments);
	}

	@action
	async createEntries()
	{
		var destinationEvent = this.args.destinationEvent;
		var destinationEntries = await destinationEvent.get('entries');
		var destinationClasses = await destinationEvent.get('classes');

		await this.sprintTools.createEntriesForHeat(destinationEvent, destinationEntries, destinationClasses, this.Q1ClassGroup, this.Q1Assignments, this.startTimeQ1);
		await this.sprintTools.createEntriesForHeat(destinationEvent, destinationEntries, destinationClasses, this.Q2ClassGroup, this.Q2Assignments, this.startTimeQ2);
		await this.sprintTools.createEntriesForHeat(destinationEvent, destinationEntries, destinationClasses, this.Q3ClassGroup, this.Q3Assignments, this.startTimeQ3);
		await this.sprintTools.createEntriesForHeat(destinationEvent, destinationEntries, destinationClasses, this.Q4ClassGroup, this.Q4Assignments, this.startTimeQ4);
		await this.sprintTools.createEntriesForHeat(destinationEvent, destinationEntries, destinationClasses, this.Q5ClassGroup, this.Q5Assignments, this.startTimeQ5);
	}

	// Helper to assign a result to a heat
	assignToHeat(assignments, result, bib, heatStartOrder, bibOffset)
	{
		if(result)
		{
			result.set('newBib', bib + bibOffset);
			result.set('heatStartOrder', heatStartOrder);
			assignments.push(result);
		}
	}

	updateHeatAssignments()
	{
		var bibOffset = parseInt(this.bibOffset);

		if(	this.Q1ClassGroup == null ||
			this.Q2ClassGroup == null ||
			this.Q3ClassGroup == null ||
			this.Q4ClassGroup == null ||
			this.Q5ClassGroup == null)
		{
			return;
		}

		if(this.top50Results == null)
		{
			return;
		}

		var Q1Assignments = [];
		var Q2Assignments = [];
		var Q3Assignments = [];
		var Q4Assignments = [];
		var Q5Assignments = [];

		// Distribution for "50" format (10 per heat):
		// Q1: 1, 10, 11, 20, 21, 30, 31, 40, 41, 50
		// Q2: 4, 7, 14, 17, 24, 27, 34, 37, 44, 47
		// Q3: 5, 6, 15, 16, 25, 26, 35, 36, 45, 46
		// Q4: 2, 9, 12, 19, 22, 29, 32, 39, 42, 49
		// Q5: 3, 8, 13, 18, 23, 28, 33, 38, 43, 48

		var results = this.top50Results;

		// Q1: 1, 10, 11, 20, 21, 30, 31, 40, 41, 50
		if(results.length > 0) this.assignToHeat(Q1Assignments, results[0], 1, 1, bibOffset);
		if(results.length > 9) this.assignToHeat(Q1Assignments, results[9], 10, 2, bibOffset);
		if(results.length > 10) this.assignToHeat(Q1Assignments, results[10], 11, 3, bibOffset);
		if(results.length > 19) this.assignToHeat(Q1Assignments, results[19], 20, 4, bibOffset);
		if(results.length > 20) this.assignToHeat(Q1Assignments, results[20], 21, 5, bibOffset);
		if(results.length > 29) this.assignToHeat(Q1Assignments, results[29], 30, 6, bibOffset);
		if(results.length > 30) this.assignToHeat(Q1Assignments, results[30], 31, 7, bibOffset);
		if(results.length > 39) this.assignToHeat(Q1Assignments, results[39], 40, 8, bibOffset);
		if(results.length > 40) this.assignToHeat(Q1Assignments, results[40], 41, 9, bibOffset);
		if(results.length > 49) this.assignToHeat(Q1Assignments, results[49], 50, 10, bibOffset);

		// Q2: 4, 7, 14, 17, 24, 27, 34, 37, 44, 47
		if(results.length > 3) this.assignToHeat(Q2Assignments, results[3], 4, 1, bibOffset);
		if(results.length > 6) this.assignToHeat(Q2Assignments, results[6], 7, 2, bibOffset);
		if(results.length > 13) this.assignToHeat(Q2Assignments, results[13], 14, 3, bibOffset);
		if(results.length > 16) this.assignToHeat(Q2Assignments, results[16], 17, 4, bibOffset);
		if(results.length > 23) this.assignToHeat(Q2Assignments, results[23], 24, 5, bibOffset);
		if(results.length > 26) this.assignToHeat(Q2Assignments, results[26], 27, 6, bibOffset);
		if(results.length > 33) this.assignToHeat(Q2Assignments, results[33], 34, 7, bibOffset);
		if(results.length > 36) this.assignToHeat(Q2Assignments, results[36], 37, 8, bibOffset);
		if(results.length > 43) this.assignToHeat(Q2Assignments, results[43], 44, 9, bibOffset);
		if(results.length > 46) this.assignToHeat(Q2Assignments, results[46], 47, 10, bibOffset);

		// Q3: 5, 6, 15, 16, 25, 26, 35, 36, 45, 46
		if(results.length > 4) this.assignToHeat(Q3Assignments, results[4], 5, 1, bibOffset);
		if(results.length > 5) this.assignToHeat(Q3Assignments, results[5], 6, 2, bibOffset);
		if(results.length > 14) this.assignToHeat(Q3Assignments, results[14], 15, 3, bibOffset);
		if(results.length > 15) this.assignToHeat(Q3Assignments, results[15], 16, 4, bibOffset);
		if(results.length > 24) this.assignToHeat(Q3Assignments, results[24], 25, 5, bibOffset);
		if(results.length > 25) this.assignToHeat(Q3Assignments, results[25], 26, 6, bibOffset);
		if(results.length > 34) this.assignToHeat(Q3Assignments, results[34], 35, 7, bibOffset);
		if(results.length > 35) this.assignToHeat(Q3Assignments, results[35], 36, 8, bibOffset);
		if(results.length > 44) this.assignToHeat(Q3Assignments, results[44], 45, 9, bibOffset);
		if(results.length > 45) this.assignToHeat(Q3Assignments, results[45], 46, 10, bibOffset);

		// Q4: 2, 9, 12, 19, 22, 29, 32, 39, 42, 49
		if(results.length > 1) this.assignToHeat(Q4Assignments, results[1], 2, 1, bibOffset);
		if(results.length > 8) this.assignToHeat(Q4Assignments, results[8], 9, 2, bibOffset);
		if(results.length > 11) this.assignToHeat(Q4Assignments, results[11], 12, 3, bibOffset);
		if(results.length > 18) this.assignToHeat(Q4Assignments, results[18], 19, 4, bibOffset);
		if(results.length > 21) this.assignToHeat(Q4Assignments, results[21], 22, 5, bibOffset);
		if(results.length > 28) this.assignToHeat(Q4Assignments, results[28], 29, 6, bibOffset);
		if(results.length > 31) this.assignToHeat(Q4Assignments, results[31], 32, 7, bibOffset);
		if(results.length > 38) this.assignToHeat(Q4Assignments, results[38], 39, 8, bibOffset);
		if(results.length > 41) this.assignToHeat(Q4Assignments, results[41], 42, 9, bibOffset);
		if(results.length > 48) this.assignToHeat(Q4Assignments, results[48], 49, 10, bibOffset);

		// Q5: 3, 8, 13, 18, 23, 28, 33, 38, 43, 48
		if(results.length > 2) this.assignToHeat(Q5Assignments, results[2], 3, 1, bibOffset);
		if(results.length > 7) this.assignToHeat(Q5Assignments, results[7], 8, 2, bibOffset);
		if(results.length > 12) this.assignToHeat(Q5Assignments, results[12], 13, 3, bibOffset);
		if(results.length > 17) this.assignToHeat(Q5Assignments, results[17], 18, 4, bibOffset);
		if(results.length > 22) this.assignToHeat(Q5Assignments, results[22], 23, 5, bibOffset);
		if(results.length > 27) this.assignToHeat(Q5Assignments, results[27], 28, 6, bibOffset);
		if(results.length > 32) this.assignToHeat(Q5Assignments, results[32], 33, 7, bibOffset);
		if(results.length > 37) this.assignToHeat(Q5Assignments, results[37], 38, 8, bibOffset);
		if(results.length > 42) this.assignToHeat(Q5Assignments, results[42], 43, 9, bibOffset);
		if(results.length > 47) this.assignToHeat(Q5Assignments, results[47], 48, 10, bibOffset);

		this.Q1Assignments = Q1Assignments;
		this.Q2Assignments = Q2Assignments;
		this.Q3Assignments = Q3Assignments;
		this.Q4Assignments = Q4Assignments;
		this.Q5Assignments = Q5Assignments;
	}

	async updateResults()
	{
		if(this.sourceClassGroup == null)
		{
			this.top50Results = null;
			this.updateHeatAssignments();
			return;
		}

		var top50Results = [];

		await this.sprintTools.fetchResultsForEvent(this.sourceEvent.id);

		var results = await this.sourceClassGroup.get('resultsSorted');

		var count = 0;
		for (const result of results)
		{
			if(count < 50)
			{
				count++;
				result.set('useResultForTie',false);
				top50Results.push(result);
			}
		}

		// Check if 50th place is a tie
		if(results.length > 49 && results[49].isTie)
		{
			if(results.length > 50 && results[50].isTie)
			{
				var result50time = results[50].totalTimeFormatted;
				var result49time = results[49].totalTimeFormatted;

				if(result50time == result49time)
				{
					alert('tie between 50th and 51st place');
					results[50].set('useResultForTie',false);
					top50Results.push(results[50]);
				}
			}
		}

		// Sort by time, break ties by lowest SP points
		top50Results.sort((a, b) => this.sprintTools.sortByTimeWithTieBreaker(a, b));

		this.top50Results = top50Results;
		this.updateHeatAssignments();
	}
}
